import isomorphic from '../../../lib/fetch';

export const FETCH_STOREFRONT_DATA = 'FETCH_STOREFRONT_DATA';

const previewStorefrontAction = payload => ({ type: 'FETCH_STOREFRONT_DATA_FULFILLED', payload });

const url = (partnerId, lastPublication, storefrontUrl) => `${storefrontUrl}/${partnerId}?l=${lastPublication}`;

export const requestStorefront = (props = {}) => {
  const { initialState = { session: {} } } = props;
  const partnerId = initialState.session.partnerId;
  const lastPublication = initialState.session.lastPublication || '';

  if (!partnerId) {
    return { type: '' };
  }

  return ({
    type: FETCH_STOREFRONT_DATA,
    payload: isomorphic.fetch
      .get(url(partnerId, lastPublication, process.env.TOGA_BASE_URL_STOREFRONT)),
    partnerId
  });
};

export const storefrontData = data => previewStorefrontAction({ data });

export const previewStorefront = (data) => {
  return (dispatch) => {
    dispatch(previewStorefrontAction({ data }));
  };
};



// WEBPACK FOOTER //
// ./src/components/storefront/actions/index.js